module.exports = __webpack_public_path__ + "img/icon_cancelB.11286acd.svg";